/** Must match `CURRENT_LOBBY_KEY` in lobby / content / game / host. */
export const MYTH_FACT_LOBBY_STORAGE_KEY = "mythFactCurrentLobby";

function pickLobbyFromSearchParams(sp) {
  if (!sp) return "";
  const candidates = [
    sp.get("lobby"),
    sp.get("lobbyName"),
    sp.get("room"),
    sp.get("roomName"),
  ];
  for (const c of candidates) {
    const t = String(c ?? "").trim();
    if (t) return t.slice(0, 80);
  }
  return "";
}

/**
 * Reads join/share lobby id from a query string and stores it for `/addContent`, `/game`, etc.
 * Join links use `?lobby=LOBBY-XXXX` (see host.jsx / extramile appendLobbyShareFlagsToJoinUrl).
 */
export function syncJoinLobbyFromUrlSearch(searchString) {
  try {
    const raw =
      typeof searchString === "string"
        ? searchString
        : typeof window !== "undefined"
          ? window.location.search
          : "";
    const sp = new URLSearchParams(raw);
    const lobby = pickLobbyFromSearchParams(sp);
    if (lobby) {
      sessionStorage.setItem(MYTH_FACT_LOBBY_STORAGE_KEY, lobby);
      return lobby;
    }
  } catch {
    /* ignore storage / URL errors */
  }
  return "";
}
